import * as types from '../actions/actionTypes';

const initialState = {
  isSwitching : false,
  activeStep: 0,
  layoutParts: [],
};

export default function(state = initialState, action) {

  switch(action.type) {

    case types.SET_STEP:

      if (state.isSwitching) {
        return Object.assign({}, state) // don't do anything until animation will finish
      }

      if (action.payload.activeStep > state.layoutParts.length - 1) {
        return Object.assign({}, state, {
          activeStep: action.payload.activeStep - 1
        })
      } else {
        return Object.assign({}, state, {
          activeStep: action.payload.activeStep <= 0 ? 0 : action.payload.activeStep
        });
      }

    case types.SET_STEP_SWITCHING:
    case types.SET_LAYOUT_DATA_PARTS:
      return Object.assign({}, state, {
        ...action.payload
      });

  }

  return state;

}